import React from 'react';
import { useAppContext } from 'Context/ReactAppContext';
import { getKeyValue, t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { getFormatedPriceByLocale } from 'Utils/proposal/proposalUtils';
import { isSeller } from 'Utils/seller/sellerUtils';
export type AccommodationOptionPriceProps = {
  currency: string;
  isUpgradableOnline: boolean;
  nigthly: number;
  total: number;
};
type Props = AccommodationOptionPriceProps & {
  className?: string;
};
export const AccommodationOptionPrice = ({
  className,
  currency,
  nigthly,
  total,
  isUpgradableOnline = true,
}: Props) => {
  const appContext = useAppContext();
  const { locale } = appContext;
  const displayPricePerNightB2C = getKeyValue(
    'booking.accommodation.moreRooms.displayPricePerNight_B2C',
  );
  const displayPricePerNightB2B = getKeyValue(
    'booking.accommodation.moreRooms.displayPricePerNight_B2B',
  );
  const displayPricePerNight =
    (!isSeller(appContext) && displayPricePerNightB2C) ||
    (isSeller(appContext) && displayPricePerNightB2B);
  let testId;
  let labelText;

  if (!isUpgradableOnline) {
    testId = 'AccommodationOptionPrice-notUpgradable';
    labelText = t('booking.accommodation.upgradeRoom.villaPricing');
  } else if (displayPricePerNight && nigthly !== 0) {
    testId = 'AccommodationOptionPrice-perNight';
    labelText = t('booking.accommodation.moreRooms.perNight');
  } else if (total === 0) {
    testId = 'AccommodationOptionPrice-mention';
    labelText = t('booking.accommodation.moreRooms.includedRoom');
  }

  const label = labelText ? <span data-testid={testId}>{labelText}</span> : '';
  return (
    <p
      className={classnames('flex gap-5 text-18 font-bold text-sienna', className)}
      data-testid="AccommodationOptionPrice"
    >
      {isUpgradableOnline &&
        getFormatedPriceByLocale(displayPricePerNight ? nigthly : total, locale, currency)}
      {label}
    </p>
  );
};
